import type React from "react";
import type { LocalizedText } from "@shared/schemas/localized-text.schemas";
import { LocalizedTextUtils } from "@shared/utils/localized-text.utils";
import { PorterOrb } from "../PorterOrb";
import { i18n } from "@frontend/i18n";

export interface AISummarySectionProps {
  readonly summary: LocalizedText;
}

export function AISummarySection({
  summary,
}: AISummarySectionProps): React.JSX.Element {
  return (
    <div className="flex flex-col gap-2" data-testid="ai-summary-section">
      <p
        className="flex items-center gap-1.5 text-pds-2xs text-muted-foreground"
        data-testid="ai-summary-badge"
      >
        <PorterOrb className="size-3.5 shrink-0" />
        {i18n.t("participantProfile.aiSummary")}
      </p>
      <p className="text-pds-xs text-foreground leading-normal">
        {LocalizedTextUtils.resolve(summary, i18n.getLocale())}
      </p>
    </div>
  );
}
